import RGService from "../services/radarGridService";
import { createPathFeatures } from "@/views/enterprise/live-map/layers/radar-grid/utils/GeoUtil";
import { RADAR_GRID_IDS } from "@/views/enterprise/live-map/layers/radar-grid/consts/radarGridLayerConstants";
import { featureCollection } from "@turf/helpers";
import Vue from "vue";

export function usePathManager({ map }) {
  const pathData = new Map(); // objectId -> [{lon, lat}, {lon, lat}]

  /** RGオブジェクトクリック時に過去航跡をセット */
  const setPastPath = async id => {
    try {
      const result = await RGService.fetchPastPath(id);
      const points = result.p.map(p => ({
        lon: p.lon,
        lat: p.lat,
        v: p.v,
        d: p.d,
      }));

      if (points.length >= 2) {
        pathData.set(id, points);
        await updateAllPaths();
      } else {
        Vue.$log.warn(
          `[警告] 航跡データが少なすぎるためセットしません id=${id}`
        );
      }
    } catch (e) {
      Vue.$log.error(`[エラー] 航跡取得失敗 id=${id}`, e);
    }
  };

  /** 航跡に新しい位置を追加 */
  const addNewPointToPath = async (objectId, latestObject) => {
    if (!pathData.has(objectId)) {
      Vue.$log.warn(`[警告] pathDataに存在しないobjectId=${objectId}`);
      return;
    }

    const points = pathData.get(objectId);
    points.push({
      lon: latestObject.c.lon,
      lat: latestObject.c.lat,
      v: latestObject.sog || 0, // ★SOG（速度）を入れる
      d: latestObject.t,
    });

    pathData.set(objectId, points); // 更新

    await updateAllPaths(); // 再描画
  };

  /** 特定オブジェクトの航跡を削除 */
  const removeObjectFromSource = async objectId => {
    pathData.delete(objectId); // pathDataから削除
    await updateAllPaths(); // 再描画
  };

  /** pathData全体からsourceを更新 */
  const updateAllPaths = async () => {
    const allFeatures = [];

    for (const [id, points] of pathData.entries()) {
      if (!points || points.length < 2) {
        continue; // ★2点未満なら作らない
      }

      const featureCollection = await createPathFeatures(id, points);
      if (featureCollection && featureCollection.length > 0) {
        allFeatures.push(...featureCollection);
      } else {
        Vue.$log.warn(`[警告] createPathFeatures失敗 id=${id}`, points);
      }
    }

    const source = map.getSource(RADAR_GRID_IDS.RG_PATH_SOURCE_ID);
    if (source) {
      source.setData(featureCollection(allFeatures));
    }
  };

  return {
    setPastPath,
    addNewPointToPath,
    removeObjectFromSource,
  };
}
